import { cva } from 'class-variance-authority';

export const profileEditorStyles = {
  container: cva([
    'border border-stroke-on-dark-subdued bg-dark-subdued-background rounded-md px-2',
  ]),
  item: cva(
    'flex items-center justify-between px-4 [&:not(:last-child)]:border-b border-stroke-on-dark-subdued text-base-white',
    {
      variants: {
        withInput: {
          true: 'py-2',
          false: 'py-6',
        },
      },
    },
  ),
  input: cva(['w-72']),
  error: cva([
    'flex rounded-md flex-grow items-center justify-center bg-red-100 p-4 text-red-500 font-semibold mb-4',
  ]),
};